import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  public readonly loading = signal<boolean>(false);

  show() {
    this.loading.set(true);
  }
  hide() {
    this.loading.set(false);
  }
}
